/** @jsxImportSource @emotion/react */
import { Ref } from 'react';
import { createStyles, Typography, useTheme } from '../../../';
import { SelectOption } from '../Select';

interface Props {
  option: SelectOption;
  selected: boolean;
  highlighted?: boolean;
  optionRef: Ref<HTMLLIElement>;
  onClick: (option: SelectOption) => void;
  html?: string | null;
}

export const Option = ({
  option,
  selected,
  highlighted,
  onClick,
  optionRef,
  html,
}: Props) => {
  const { palette } = useTheme();
  const styles = useStyles();

  const onHandleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(option);
  };

  return (
    <li
      css={[
        styles.option,
        selected && styles.selectedOption,
        highlighted && styles.highlightedOption,
      ]}
      ref={optionRef}
      role="option"
      aria-selected={selected}
      aria-label={option.label}
      onMouseDown={(e) => e.preventDefault()}
      onClick={onHandleClick}
    >
      <Typography
        color={selected ? palette.primary.default : undefined}
        {...(html ? { html } : undefined)}
      >
        {!html ? option.label : null}
      </Typography>
    </li>
  );
};

const useStyles = createStyles(({ palette, spacing }) => ({
  option: {
    listStyleType: 'none',
    padding: `${spacing.xxxs} ${spacing.xxs}`,
    borderTop: `1px solid ${palette.grey.x100}`,
    ':hover': {
      background: palette.grey.x50,
    },
    '>p': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  },
  selectedOption: {
    background: palette.primary.x50,
    ':hover': {
      background: palette.primary.x200,
    },
  },
  highlightedOption: {
    background: palette.grey.x100,
  },
}));
